import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { actionAuthRequest } from '../../../auth/actions';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';
import { getIsLoginRequestSending, getAuthError } from '../../../auth/selectors';


export default ({ getState, dispatch }) => (
  function authRequiredHandler(nextState, successCallback, errorCallback) {
    if (getIsLoginRequestSending(getState())) {
      successCallback();
      return;
    }

    dispatch(
      actionAuthRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getAuthError(getState());
        if (
          error
          && !maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          errorCallback(INTERNAL_ERROR_URI);
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('authRequiredHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
